import { Button, Input } from 'ccs-ui-components';
import { Col, Row } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import { SERVICE_OPERATION_MAXLENGTH } from '../../../../../../../constants/ServiceConstants';
import { IServiceOperationValidationModel } from '../../../../../../../models';
import classes from './HeaderItemWrapper.module.scss';

interface IHeaderParamFieldProps {
  handleInputChange: (event: React.ChangeEvent<HTMLInputElement>) => void;
  serviceOpsFormData: IServiceOperationValidationModel;
  onAddHeaderHandler: () => void;
}
const HeaderParamField = ({
  handleInputChange,
  serviceOpsFormData,
  onAddHeaderHandler
}: IHeaderParamFieldProps) => {
  const { t: translate } = useTranslation();

  const HELPER_TEXT = {
    name_ht: translate('helper_text.txt_name_ht'),
    value_ht: translate('helper_text.txt_value_ht')
  };

  const isAddHeaderBtnEnabled = () =>
    !!(
      serviceOpsFormData.headerParamKey.isValid
      && serviceOpsFormData.headerParamKey.value
      && serviceOpsFormData.headerParamValue.isValid
      && serviceOpsFormData.headerParamValue.value
    );

  return (
    <Row className={classes['param-body']}>
      <Col sm={5}>
        <Input
          name="headerParamKey"
          label=""
          onChange={handleInputChange}
          value={serviceOpsFormData.headerParamKey.value}
          data-testid="header-key"
          placeholder={
            translate('service_operation_form.header_param_key') ?? ''
          }
          maxLength={Number(SERVICE_OPERATION_MAXLENGTH.headerParamMaxLength)}
          helperText={HELPER_TEXT.name_ht}
          error={!serviceOpsFormData.headerParamKey.isValid}
          errorTxt={serviceOpsFormData.headerParamKey.error}
          id="headerParamKey"
        />
      </Col>
      <Col sm={5}>
        <Input
          name="headerParamValue"
          label=""
          onChange={handleInputChange}
          value={serviceOpsFormData.headerParamValue.value}
          data-testid="header-value"
          placeholder={
            translate('service_operation_form.header_param_value') ?? ''
          }
          maxLength={Number(SERVICE_OPERATION_MAXLENGTH.headerParamMaxLength)}
          helperText={HELPER_TEXT.value_ht}
          errorTxt={serviceOpsFormData.headerParamValue.error}
          error={!serviceOpsFormData.headerParamValue.isValid}
          id="headerParamValue"
          className={classes['value-input']}
        />
      </Col>
      <Col sm={2}>
        <Button
          className={classes['add-button']}
          onClick={onAddHeaderHandler}
          disabled={!isAddHeaderBtnEnabled()}
          data-testid="add-header"
          variant="secondary"
        >
          {translate('service_operation_form.add_button')}
        </Button>
      </Col>
    </Row>
  );
};

export default HeaderParamField;
